/**
 * @file The ActionsComponent shows a row of buttons representing actions that are shown in the overlay
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { AlertsService } from '../../core/alerts.service';
import { UserService } from '../../user.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
import { ActionService } from '../../core/action.service';
/**
 * The ActionsComponent shows a row of buttons representing actions that are shown in the overlay
 * @export
 * @class ActionsComponent
 */
var ActionsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ActionsComponent, _super);
    /**
     * Creates an instance of ActionsComponent
     * @param {OverlayService} overlayService The service to start an overlay component
     * @param {SettingsService} settingsService The service that knows if an item is on time
     * @param {DomainService} domainService The service that knows the availability closed till date
     */
    function ActionsComponent(alertsService, userService, actionService) {
        var _this = _super.call(this) || this;
        _this.alertsService = alertsService;
        _this.userService = userService;
        _this.actionService = actionService;
        /**
         * Gets, sets the field that holds the entity of this action
         * @private
         * @type {Entity}
         */
        _this._item = null;
        /** The user's resource OID for the marketplace action */
        // private currentResourceOid;
        // REMOVE: (temporarily for faking config and form stuff), see: https://github.com/Symagic/html5/issues/580
        _this.configuration = {
            instruction: 'instructions/standaard/core/actions'
        };
        /**
         * Array of action configurations
         * @type {ActionConfiguration[]}
         */
        _this.actions = [];
        return _this;
    }
    Object.defineProperty(ActionsComponent.prototype, "item", {
        /**
         * Gets the entity of the action
         */
        get: function () {
            return this._item;
        },
        /**
         * Sets the entity of the action
         */
        set: function (value) {
            this._item = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a value indicating whether the action is allowed for the user's role
     * @param {ActionConfiguration} action The action to be checked
     * @returns {boolean} Whether the action is allowed
     */
    ActionsComponent.prototype.isAllowed = function (action) {
        return this.actionService.isAllowed(action, this.item);
    };
    /**
     * Indicates whether or not the action is disabled
     * @param {ActionConfiguration} action The action to evaluate
     * @returns {boolean} True when action is disabled
     */
    ActionsComponent.prototype.isDisabled = function (action) {
        return this.actionService.isDisabled(action, this.item);
    };
    /**
     * Returns the action's icon
     * @param {ActionConfiguration} action The action
     * @returns {string} An icon class name
     * @memberOf ActionsComponent
     */
    ActionsComponent.prototype.getIcon = function (action) {
        return this.actionService.getIcon(action);
    };
    /**
     * Returns the action's label key
     * @param {ActionConfiguration} action The action
     * @returns {string} A translation label
     * @memberOf ActionsComponent
     */
    ActionsComponent.prototype.getLabelKey = function (action) {
        return this.actionService.getLabelKey(action);
    };
    /**
     * Starts a component in the overlay depicting this action
     * @param {ActionConfiguration} action The configuration of this action
     */
    ActionsComponent.prototype.invoke = function (action) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, message, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = {
                            actionConfiguration: action,
                            item: this.item
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.actionService.doAction(input)];
                    case 2:
                        message = _a.sent();
                        if (message) {
                            this.alertsService.createAlert('success', message);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (error_1) {
                            if (!error_1.labelKey) {
                                return [2 /*return*/, this.alertsService.createAlert('danger', 'APP.SOCIAL.ACTION_NOT_FOUND', new Error('No labelKey is found'))];
                            }
                            if (!error_1.message) {
                                return [2 /*return*/, this.alertsService.createAlert('danger', error_1.labelKey)];
                            }
                            return [2 /*return*/, this.alertsService.createAlert('danger', error_1.labelKey, error_1.message)];
                        }
                        return [2 /*return*/, this.alertsService.createAlert('danger', 'APP.SOCIAL.ACTION_NOT_FOUND', new Error('Received Error is undefined'))];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ActionsComponent;
}(AbstractBase));
export { ActionsComponent };
